'use strict';

export default class Products {
    constructor() {
        $('.-js-toggle-prods').on('click', function () {
            $.fancybox.open('<div class="message">' + $(this).next().html() + '</div>');
        });
    }
}
